// extracted by mini-css-extract-plugin
export var pageContainer = "layout-module--page-container--cc90a";
export var pageContent = "layout-module--page-content--72f09";